import * as AmplitudeSDK from '@amplitude/analytics-browser'
import createAdapter from './createAdapter'

export const amplitude = createAdapter(() => true, {
  init: () => {
    AmplitudeSDK.init(process.env.AMPLITUDE_API_KEY!, {
      defaultTracking: false,
      serverZone: 'EU',
    })
  },
  track: (eventName: string, properties?: Record<string, unknown>) => {
    AmplitudeSDK.track(eventName, properties)
  },
  setUserId: (userId: string | undefined) => {
    AmplitudeSDK.setUserId(userId)
  },
  setUserProperties: (properties: Record<string, unknown>) => {
    const identify = new AmplitudeSDK.Identify()
    Object.entries(properties).forEach(([key, value]) => {
      identify.set(key, value as string | number | boolean)
    })
    AmplitudeSDK.identify(identify)
  },
  reset: () => {
    AmplitudeSDK.reset()
  },
})
